import { useTranslation } from '@rhino-project/core/i18n';
import { Button, Typography } from '@heroui/react';
import { useUser } from '@rhino-project/core/hooks';
import { useSignOutAction } from '@rhino-project/core/queries';

const NoOrganizationPage = () => {
  const { t } = useTranslation();

  const user = useUser();
  const { mutate: signOutAction } = useSignOutAction();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-4">
      <div className="bg-surface border border-separator rounded-2xl w-full max-w-sm p-8 flex flex-col items-center gap-4 text-center">
        <div>
          <Typography.Heading level={1} align="center" className="mb-2">
            {t('frontend.messages.no_organization_yet')}
          </Typography.Heading>
          <Typography.Paragraph color="muted" align="center">
            {t('frontend.messages.no_organization_description', {
              account: user?.email ?? t('frontend.messages.your_account')
            })}
          </Typography.Paragraph>
        </div>
        <Button variant="ghost" size="sm" onPress={() => signOutAction()}>
          {t('frontend.messages.sign_out')}
        </Button>
      </div>
    </div>
  );
};

export default NoOrganizationPage;
